import { render, staticRenderFns } from "./ConfirmationDataItem.vue?vue&type=template&id=d5ca3530&scoped=true&"
import script from "./ConfirmationDataItem.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDataItem.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationDataItem.vue?vue&type=style&index=0&id=d5ca3530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ca3530",
  null
  
)

export default component.exports